var React = require('react');

function ArrowRightSmall (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Layer_1","key":0}),React.createElement("g",{"id":"Layer_4","key":1},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M10.3275213,7.3116179c-0.4570274,0-0.8275204,0.3704939-0.8275204,0.8275204v7.7215929\n\t\t\t\tc-0.0000725,0.4570274,0.3703632,0.8275795,0.8273907,0.8276501c0.2029591,0.0000324,0.3988514-0.0745239,0.5504303-0.2094917\n\t\t\t\tl4.342-3.8587284c0.3427706-0.3022947,0.3755817-0.825223,0.073287-1.1679935\n\t\t\t\tc-0.0228739-0.0259361-0.0473509-0.0504131-0.073287-0.073287l-4.342-3.8603826\n\t\t\t\tC10.7256136,7.3849726,10.5299969,7.3114328,10.3275213,7.3116179z"}))))]);
}

ArrowRightSmall.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = ArrowRightSmall;

ArrowRightSmall.default = ArrowRightSmall;
